import { NullableString } from "@/code/Types";
import { ServiceNames } from "./BaseDocumentService";
import { BaseService } from "./BaseService";

export class UploadFilesService extends BaseService {
  async upload(filelist: File[], id: NullableString): Promise<void> {
    try {
      await Promise.all(
        filelist.map(async (file) => {
          const formData = new FormData();
          formData.append("file", file);
          await this.client.post<boolean>(
            `/api/${ServiceNames.Upload}?caseId=` + id,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            },
          );
        }),
      );
    } catch (error) {
      console.log(error);
    }
  }

  async remove(filepath: string): Promise<void> {
    try {
      await this.client.delete<boolean>(
        `/api/${ServiceNames.Upload}?filepath=` + filepath
      );
    }
    catch (error) {
      console.log(error);
    }
  }
}
